export const ZIP_REQUIRED_COUNTRY = 'US'

export const isBillingComplete = (country: string | null | undefined, zip: string | null | undefined): boolean => {
  if (!country) return false
  if (country !== ZIP_REQUIRED_COUNTRY) return true

  return !!zip?.trim()
}
